export default {
  dismissText: 'Cancel'
};
